import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tun-tunify-icon',
  templateUrl: './tunify-icon.component.html',
  styleUrls: ['./tunify-icon.component.scss']
})
export class TunifyIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
